(function () {
  'use strict';

  function initCarouselNow(root) {
    var track = root.querySelector('[data-vtc-track]');
    var prevBtn = root.querySelector('[data-vtc-prev]');
    var nextBtn = root.querySelector('[data-vtc-next]');
    var ctaBtn = root.querySelector('[data-vtc-cta]');
    if (!track) return;

    var originalCards = Array.prototype.slice.call(track.querySelectorAll('[data-vtc-card]'));
    var count = originalCards.length;
    if (count === 0) return;

    // How many clones we need on each side so the loop never
    // shows empty space, even on very wide screens.
    var cloneCount = Math.min(count, 8);

    function playVideosIn(el) {
      var videos = el.querySelectorAll('video');
      videos.forEach(function (v) {
        v.muted = true;
        v.loop = true;
        v.playsInline = true;
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      });
    }

    // Only start loading/playing a video once its card is actually
    // near the visible area, instead of firing every video at once
    // (including all the off-screen loop clones) the moment the page
    // loads. That was the main cause of slow initial playback — up
    // to 3x the visible number of videos were all competing for
    // bandwidth simultaneously on load.
    function playVideoNow(v) {
      v.muted = true;
      v.loop = true;
      v.playsInline = true;
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    }

    function lazyPlayVideosIn(el) {
      var videos = Array.prototype.slice.call(el.querySelectorAll('video'));

      // Cards flagged eager (the ones visible right when the page
      // loads, matching the preload="auto" cards from Liquid) start
      // playing immediately — no waiting on scroll position at all,
      // so they're already buffering/playing as fast as the browser
      // can manage.
      var eagerVideos = videos.filter(function (v) {
        var card = v.closest('[data-vtc-card]');
        return card && card.getAttribute('data-vtc-eager') === 'true';
      });
      var lazyVideos = videos.filter(function (v) {
        return eagerVideos.indexOf(v) === -1;
      });

      eagerVideos.forEach(playVideoNow);

      if (lazyVideos.length === 0) return;

      if (!('IntersectionObserver' in window)) {
        // Fallback for very old browsers: just play everything.
        lazyVideos.forEach(playVideoNow);
        return;
      }
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            playVideoNow(entry.target);
            observer.unobserve(entry.target);
          });
        },
        {
          root: null,
          rootMargin: window.matchMedia('(max-width: 749px)').matches ? '0px 150px' : '400px 800px',
          threshold: 0.01
        }
      );
      lazyVideos.forEach(function (v) {
        observer.observe(v);
      });
    }

    function cloneCard(card) {
      var clone = card.cloneNode(true);
      clone.setAttribute('data-vtc-clone', 'true');
      clone.removeAttribute('data-vtc-card-index');
      return clone;
    }

    // Prepend clones of the last N cards, append clones of the first N cards.
    // Built with a DocumentFragment so the clones land in the correct
    // order in one insert — inserting one-by-one via insertBefore(firstChild)
    // in a loop silently reverses the order, which is a real bug (fixed here).
    var headFragment = document.createDocumentFragment();
    for (var i = count - cloneCount; i < count; i++) {
      headFragment.appendChild(cloneCard(originalCards[i]));
    }
    track.insertBefore(headFragment, track.firstChild);

    var tailClones = [];
    for (var j = 0; j < cloneCount; j++) {
      tailClones.push(cloneCard(originalCards[j]));
    }
    tailClones.forEach(function (c) {
      track.appendChild(c);
    });

    var allCards = Array.prototype.slice.call(track.querySelectorAll('[data-vtc-card]'));

    function cardStep() {
      var style = getComputedStyle(track);
      var gap = parseFloat(style.columnGap || style.gap || 0);
      var cardWidth = allCards[0].getBoundingClientRect().width;
      return cardWidth + gap;
    }

    function scrollToIndex(index, smooth) {
      var target = allCards[index];
      if (!target) return;
      var trackRect = track.getBoundingClientRect();
      var cardRect = target.getBoundingClientRect();
      var delta = (cardRect.left + cardRect.width / 2) - (trackRect.left + trackRect.width / 2);
      track.scrollTo({
        left: track.scrollLeft + delta,
        behavior: smooth ? 'smooth' : 'auto'
      });
    }

    // Start centered on the first "real" card (after the head clones).
    function goToStart() {
      scrollToIndex(cloneCount, false);
    }

    function closestCardIndex() {
      var trackRect = track.getBoundingClientRect();
      var centerX = trackRect.left + trackRect.width / 2;
      var closestIdx = cloneCount;
      var closestDist = Infinity;
      allCards.forEach(function (card, idx) {
        var r = card.getBoundingClientRect();
        var cardCenter = r.left + r.width / 2;
        var dist = Math.abs(cardCenter - centerX);
        if (dist < closestDist) {
          closestDist = dist;
          closestIdx = idx;
        }
      });
      return closestIdx;
    }

    // Keep the "Se produkt" button pinned right above the title
    // of whichever card is currently centered.
    function positionCta() {
      if (!ctaBtn) return;
      var idx = closestCardIndex();
      var card = allCards[idx];
      if (!card) return;
      var refEl = card.querySelector('.vtc-card__title') || card.querySelector('.vtc-card__overlay');
      if (!refEl) return;
      var carouselRect = root.getBoundingClientRect();
      var refRect = refEl.getBoundingClientRect();
      var gap = 14;
      var top = (refRect.top - carouselRect.top) - ctaBtn.offsetHeight - gap;
      ctaBtn.style.top = top + 'px';
    }

    var settleTimer = null;
    function handleLoopBoundary() {
      var idx = closestCardIndex();
      // If we've drifted into the head clone zone, jump forward by `count`.
      if (idx < cloneCount) {
        var jumpFwd = idx + count;
        scrollToIndex(jumpFwd, false);
      }
      // If we've drifted into the tail clone zone, jump back by `count`.
      else if (idx >= cloneCount + count) {
        var jumpBack = idx - count;
        scrollToIndex(jumpBack, false);
      }
    }

    track.addEventListener('scroll', function () {
      positionCta();
      if (settleTimer) clearTimeout(settleTimer);
      settleTimer = setTimeout(handleLoopBoundary, 120);
    });

    // Arrow navigation
    function step(direction) {
      var idx = closestCardIndex();
      scrollToIndex(idx + direction, true);
    }
    if (prevBtn) prevBtn.addEventListener('click', function () { step(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { step(1); });

    // Click a card to bring it to center
    allCards.forEach(function (card, idx) {
      card.addEventListener('click', function (e) {
        if (track.classList.contains('was-dragged')) {
          track.classList.remove('was-dragged');
          return;
        }
        scrollToIndex(idx, true);
      });
    });

    // Pointer drag-to-scroll — only for mouse. On touch, we let the
    // browser's native touch scrolling + CSS scroll-snap handle it,
    // since that has proper momentum/inertia and feels far smoother
    // than us manually setting scrollLeft on every pointermove.
    var isDown = false;
    var startX = 0;
    var startScroll = 0;
    var moved = false;

    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse') return;
      isDown = true;
      moved = false;
      track.classList.add('is-dragging');
      startX = e.clientX;
      startScroll = track.scrollLeft;
      track.setPointerCapture(e.pointerId);
    });

    track.addEventListener('pointermove', function (e) {
      if (!isDown) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 3) moved = true;
      track.scrollLeft = startScroll - dx;
    });

    function endDrag() {
      if (!isDown) return;
      isDown = false;
      track.classList.remove('is-dragging');
      if (moved) {
        track.classList.add('was-dragged');
        // snap to nearest card after releasing
        setTimeout(function () {
          scrollToIndex(closestCardIndex(), true);
        }, 10);
      }
    }
    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointerleave', endDrag);
    track.addEventListener('pointercancel', endDrag);

    // Load/play videos lazily as their cards approach the visible area,
    // instead of starting every video (including off-screen loop clones)
    // at once.
    lazyPlayVideosIn(track);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) return;
      // Only resume videos that had already started loading — this
      // does not force-start videos the IntersectionObserver hasn't
      // reached yet.
      track.querySelectorAll('video').forEach(function (v) {
        if (v.readyState > 0 && v.paused) {
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        }
      });
    });

    // Recenter on resize (card width / gap can change via breakpoints)
    var resizeTimer = null;
    window.addEventListener('resize', function () {
      if (resizeTimer) clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        scrollToIndex(closestCardIndex(), false);
        positionCta();
      }, 150);
    });

    // Initial position
    requestAnimationFrame(function () {
      goToStart();
      // Wait a frame for layout to settle before measuring.
      requestAnimationFrame(positionCta);
    });

    // Re-assert the starting card once more after everything (including
    // videos) has had a chance to load — guards against the very first
    // block drifting off-center if something shifts the layout slightly
    // after the initial position was set (e.g. a scrollbar appearing).
    window.addEventListener('load', function () {
      goToStart();
      positionCta();
    });
  }

  // Defer the entire carousel setup (card cloning, video observers,
  // everything) until the carousel is actually getting close to the
  // visible area — not just the individual videos inside it. If the
  // carousel sits below the fold, none of this work happens until
  // the visitor scrolls near it, so it never competes with whatever
  // is loading above the fold first.
  function initCarousel(root) {
    if (root.dataset.vtcInitDone === 'true') return;

    if (!('IntersectionObserver' in window)) {
      root.dataset.vtcInitDone = 'true';
      initCarouselNow(root);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          if (root.dataset.vtcInitDone === 'true') return;
          root.dataset.vtcInitDone = 'true';
          initCarouselNow(root);
          observer.disconnect();
        });
      },
      { root: null, rootMargin: '800px 0px', threshold: 0.01 }
    );
    observer.observe(root);
  }

  function initAll() {
    document.querySelectorAll('[data-vtc-carousel]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Theme editor support
  document.addEventListener('shopify:section:load', function (e) {
    var carousel = e.target.querySelector('[data-vtc-carousel]');
    if (carousel) initCarouselNow(carousel);
  });
})();
